import { render, staticRenderFns } from "./operationLog.vue?vue&type=template&id=20e52156&scoped=true"
import script from "./operationLog.vue?vue&type=script&lang=js"
export * from "./operationLog.vue?vue&type=script&lang=js"
import style0 from "./operationLog.vue?vue&type=style&index=0&id=20e52156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e52156",
  null
  
)

export default component.exports